module.exports = __webpack_public_path__ + "static/img/sign-up.606616e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/sign-up.png
// module id = teDP
// module chunks = 36